import { GetStaticProps } from "next";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { useTina } from "tinacms/dist/react";
import { TinaMarkdown } from "tinacms/dist/rich-text";

import { getWebsiteUrl } from "@/constants";
import BlogPageSeo from "@/shared/components/BlogPageSeo";
import Layout from "@/shared/components/layout";
import client from "tina/__generated__/databaseClient";

export default function Resource(props: any) {
    const maindata = useTina({
        query: props.query,
        variables: props.variables,
        data: props.data,
    });
    const router = useRouter();
    const { page } = router.query;

    const content = maindata.data?.stories?.content;
    const title = maindata.data?.stories?.title;
    const heroImage = maindata.data?.stories?.heroImage;
    const author = maindata.data?.stories?.author;
    const filename = props?.data?.stories?._sys?.filename;
    const publishDate = props?.data?.stories?.date_published;
    const estimatedReadingTime = props?.data?.stories?.estimatedReadingTime;
    const canonicalUrl = props?.data?.stories?.canonicalUrl;
    const heroImageAltText = props?.data?.stories?.heroImageAltText;
    const description = props?.data?.stories?.description;
    const url = `${getWebsiteUrl()}/stories/${filename}`;

    return (
        <Layout>
            <BlogPageSeo
                title={title}
                author={author}
                url={url}
                description={description}
                canonicalUrl={canonicalUrl}
                estimatedReadingTime={estimatedReadingTime}
                heroImageUrl={heroImage}
                publishDate={publishDate}
            />
            <div className="multipleLayoutWrap">
                <div className='singleLayout resourcePage'>
                    <div className="backLink">
                        <Link href={`/stories${page ? `?page=${page}` : ""}`}>Back to stories</Link>
                    </div>
                    {
                        title
                        && <h1 className="title">
                            {title}
                        </h1>
                    }
                    {
                        heroImage
                        && <Image
                            src={heroImage}
                            alt={heroImageAltText ? heroImageAltText : "Stories Image"}
                            className="heroImage"
                            loading="lazy"
                            width={600}
                            height={600}
                        />
                    }
                    <div className="markdown">
                        <TinaMarkdown content={content} />
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export const getStaticProps: GetStaticProps<any, { filename: string }> = async ({ params }) => {
    const tinaProps = await client.queries.stories({
        relativePath: `${params?.filename}.md`,
    });
    const props = {
        ...tinaProps,
        enableVisualEditing: process.env.VERCEL_ENV === "preview",
    };
    return {
        props: JSON.parse(JSON.stringify(props)) as typeof props,
    };
};

export const getStaticPaths = async () => {
    const pagesListData = await client.queries.storiesConnection();
    return {
        paths: pagesListData.data.storiesConnection?.edges?.map((page) => ({
            params: { filename: page?.node?._sys.filename },
        })),
        fallback: false,
    };
};
